import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import TableComponentPage4 from '../../Table/GroupTable';
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select'
import { useSelector } from 'react-redux';

function AffliateReview() {
    const [affiliatList, setAffliateList] = useState([]);
    const [affPages, setAffPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [resetTable, setResetTable] = useState(false);
    const [ltComGrp, setLtComGrp] = useState([])
    const [ltAffGrp, setLtAffGrp] = useState([])
    const [affliatePermission, setAffliatePermission] = useState(false)
    const [affiliateFilter, setAffiliateFilter] = useState
        ({
            filters: {
                currency: "",
                commissiongroup: "",
                affiliategroup: "",
                language: "",
                btag: "",
                websiteid: "",
                status: "1"

            }
        })
    const [selectedRows, setSelectedRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [affBtnLoading, setAffBtnLoading] = useState(false);
    const [affliate, setAffliate] = useState({});

    const [AffiliateStatus, setAffiliateStatus] = useState({
        status: "",
        commissiongroup: 0,
        affiliategroup: 0,
        ids: []
    });
    const StoreUser = useSelector((state) => state.user);
    const checkPermission = (user, permission) => {
        var Permissions = user.Permissions;
        if (Permissions && Permissions.length > 0) {
            const index = Permissions.findIndex(per => per === permission)
            if (index != -1) return true;
            else return false;
        }
        return true
    }
    const getAllAffliates = async () => {
        setAffliateList([])
        setSelectedRows([])
        setLoading(true)
        const response = await axios.post(window.__CFG.API + "affiliates/ListAffiliates?page=" + currentPage, affiliateFilter, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        setLoading(false)
        if (response.data.Error == null) {
            setAffPages(response.data.Result.Pages)
            setAffliateList(response.data.Result.Data)
        }
    }
    const handleSelectedRowsChange = (selectedRows) => {
        setSelectedRows(selectedRows);
    }
    const changeaffiliateStatus = async () => {
        var selectedAffilates = []
        if (selectedRows.length > 0) {
            selectedRows.forEach(aff => {
                selectedAffilates.push(aff.id)
            })
            AffiliateStatus.ids = selectedAffilates;
            setLoading(true)
            setAffBtnLoading(true)
            const response = await axios.post(window.__CFG.API + "affiliates/ChangeAffiliateStatus", AffiliateStatus, {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("raff-token")
                }
            })

            setLoading(false)
            if (response.data.Error == null) {
                setAffBtnLoading(false)
                toast.success("Updated Sucessufully", {
                    duration: 4000
                });
                setAffiliateStatus({
                    status: "",
                    commissiongroup: 0,
                    affiliategroup: 0,
                    ids: []
                })
                resetTableState()
                getAllAffliates()
            }
        }
        else {
            toast.error("Please select affiliate", {
                duration: 4000
            });
        }
    }
    useEffect(() => { getAllAffliates() }, [currentPage, affiliateFilter])
    const resetTableState = () => {
        setSelectedRows([]);
        setResetTable(!resetTable); // This toggle forces the TableComponentPage4 to reset
    };
    const columns = [
        {
            Header: 'Affiliate ID',
            accessor: 'id', // accessor is the "key" in the data
        },
        {
            Header: 'Username',
            accessor: 'username',
        },
        {
            Header: 'Email',
            accessor: 'email',
        },
        {
            Header: 'Email Verified',
            accessor: 'emailVerified',
        },
        {
            Header: 'Country',
            accessor: 'country',
        },
        {
            Header: 'Site',
            accessor: 'site',
        },
        {
            Header: 'Register date',
            accessor: 'registrationdate',
        },
        {
            Header: 'Introduced By',
            accessor: 'introducedBy',
        },
        {
            Header: 'Status',
            accessor: 'status',
        },

    ]
    const getListAffliateGrp = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllAffiliateGroups", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtAffGrp(response.data.Result)
        }
    }
    const getListCommissionGrp = async () => {
        const response = await axios.get(window.__CFG.API + "manager/ListAllCommissionGroups", {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("raff-token")
            }
        })
        if (response.data.Error === null) {
            setLtComGrp(response.data.Result)
        }
    }
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    useEffect(() => { getListAffliateGrp(); getListCommissionGrp(); }, [])
    useEffect(() => { setAffliatePermission(checkPermission(affliate, "aff_affiliate_review")) }, [affliate])
    useEffect(() => {
        if (StoreUser != undefined) {
            setAffliate(StoreUser.User)
        }
    }, [affliate])
    const optionsCurrency = [{ label: "USD", value: 1 }]
    const optionsStatus = [{ label: "Active", value: 0 }, { label: "Inactive", value: 1 }, { label: "On Review", value: 2 }, { label: "Declined", value: 3 }]
    const selectedStatusValue = optionsStatus.find(option => option.value === parseInt(affiliateFilter.filters.status))
    const selectedCurrencyValue = optionsCurrency.find(option => option.value === 1)

    return (
        <>
            <div>
                <div>
                    {/* <CustomNavbar /> */}
                </div>
                <div>
                    <Container>
                        <Row >
                            <Col>

                                <Row className="justify-content-between mt-4">
                                    <Col lg={3} md={4} sm={4}>
                                        <div className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                                <label>Status </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in r-sel">
                                                <Select isDisabled={!affliatePermission} options={optionsStatus} value={selectedStatusValue} onChange={e => { setAffiliateFilter(prevstat => ({ ...prevstat, filters: { ...prevstat.filters, status: e.value } })) }} />
                                            </div>
                                        </div>

                                    </Col>

                                </Row>
                                <Row className="mt-2 mb-4">
                                    <div className="aff-dash-summary-table">
                                        <TableComponentPage4 key={resetTable} columns={columns} data={affiliatList} onSelectedRowsChange={handleSelectedRowsChange} Pages={affPages} currentPage={currentPage} onPageChange={handlePageChange} loading={loading} linkUrl={`/affiliate/details?id=`} linkColumn={checkPermission(affliate, "aff_edit_affiliates") ? "id" : ""} />
                                    </div>

                                </Row>


                                <Row className="justify-content-between mt-4 me-auto w-150">
                                    <Col lg={3} md={4} sm={4}>
                                        <div className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                                <label>Status </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">

                                                <Select isDisabled={!affliatePermission} options={optionsStatus} onChange={e => setAffiliateStatus({ ...AffiliateStatus, status: parseInt(e.value) })} />

                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={3} md={4} sm={4}>
                                        <div className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                                <label>Currency </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">
                                                <Select isDisabled={!affliatePermission} options={optionsCurrency} value={selectedCurrencyValue} />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={3} md={4} sm={4}>
                                        <div className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                                <label>Commission group </label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">
                                                <Select isDisabled={!affliatePermission} options={ltComGrp.filter(d => {
                                                    return d.value != ""
                                                })} onChange={e => setAffiliateStatus({ ...AffiliateStatus, commissiongroup: e.value })} />

                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={3} md={4} sm={5}>
                                        <div className="form-cre-grp-fl-wp-gd">
                                            <div className="form-cre-grp-fl-wp-lb">
                                                <label>Affiliate Group</label>
                                            </div>
                                            <div className="form-cre-grp-fl-wp-in">
                                                <Select isDisabled={!affliatePermission} options={ltAffGrp.filter(d => {
                                                    return d.value != ""
                                                })} onChange={e => setAffiliateStatus({ ...AffiliateStatus, affiliategroup: e.value })} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>


                                <Row className="justify-content-start mt-4 me-auto w-100 mb-5">
                                    <Col lg={3} md={4} sm={5} className=" pt-3 md-se-btn">
                                        <Button disabled={!affliatePermission || loading} onClick={changeaffiliateStatus} className="w-100 bg-warning border-0 rounded-0 btn-height text-dark btn-com-grp">
                                            {
                                                loading ? (
                                                    <Spinner size="sm"></Spinner>
                                                ) : (
                                                    <>Apply</>
                                                )
                                            }
                                        </Button>
                                    </Col>

                                </Row>


                            </Col>


                        </Row>

                    </Container>
                </div>

            </div>
        </>
    )
}

export default AffliateReview